import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { InsightCategoryModel, InsightEntryModel } from '../../../Mentions/models/insight.model';
import { PromptModel } from '../../../Mentions/models/prompt.model';


@Component({
    selector: 'agpr-mie-interactive-list',
    templateUrl: './mie-interactive-list.component.html',
    styleUrls: ['./mie-interactive-list.component.scss'],
    animations: [
        trigger('insightState', [
            state('visible', style({
                opacity: 1,
                height: '*'
            })),
            state('hidden', style({
                opacity: 0,
                height: 0
            })),
            transition('hidden <=> visible', animate('200ms ease-in'))
        ])
    ],
    standalone: false
})
export class MieInteractiveListComponent {

    readonly buttonTypes = ButtonTypesEnum;

    @Input() prompt: PromptModel;
    @Input() categories: InsightCategoryModel[];
    @Input() isAiGenerating: boolean = false;

    @Output() generateEntryInsight = new EventEmitter<{
        categoryName: string;
        entry: InsightEntryModel;
        prompt: PromptModel;
    }>();
    @Output() toggleEntry = new EventEmitter<boolean>();

    constructor(public localizationService: LocalizationService) {}

    toggle(categoryName: string, entry: InsightEntryModel, prompt: PromptModel) {
        if (!this.isAiGenerating) {
            prompt.insightSaved = false;
            if (
                (!entry.insight || entry.insight === this.localizationService.transform('Briefings.mentionInsights.generation.failed')) &&
                !prompt.insightText
            ) {
                delete entry.insight;
                this.isAiGenerating = true;
                this.generateEntryInsight.emit({ categoryName, entry, prompt});
            } else {
                entry.expanded = !entry.expanded;
            }
        }
    }

}
